




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IInspType } from '@/api/types'

@Component({
  name: 'InspectionTypesTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IInspType>;

  @Prop({ type: Boolean })
  private _listLoading = false;

  public get listLoading() {
    return this._listLoading
  }

  public set listLoading(value) {
    this._listLoading = value
  }

  get isLoading(): boolean {
    return this._listLoading === true
  }
}
